module.exports = __webpack_public_path__ + "static/media/es-ES.d4c56f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/es-ES.png
// module id = 942
// module chunks = 0